import React from 'react';
import './Qhse.css';
import { ServiceEditModal, usePageEditor, resolveUrl } from "./serviceEditorShared";
import { CiEdit } from 'react-icons/ci';

const DEFAULT_DATA = {
  bannerImage: "",
  title:       "",
  intro:       "",
  quote:       "",
  subIntro:    "",
  policyIntro: "",
  paragraphs:  [],
  sections:    [],
};

const EXTRA_FIELDS = [
  { key: "intro",       label: "Intro Paragraph",         rows: 4 },
  { key: "quote",       label: "Pull Quote",               rows: 2 },
  { key: "subIntro",    label: "Sub-Intro",                 rows: 3 },
  { key: "policyIntro", label: "Policy Intro (before list)", rows: 2 },
];

const Qhse = () => {
  const {
    pageData, loading, fetchErr, fetchData,
    modalOpen, setModalOpen, saving, handleSave, saveMsg,
  } = usePageEditor("/api/qhse", DEFAULT_DATA);

  const bannerImg  = resolveUrl(pageData.bannerImage);
  const hasContent = Boolean(pageData.title);

  return (
    <>
      <button
        title="Edit page"
        onClick={() => setModalOpen(true)}
        style={{ position: "absolute", top: 70, right: 20, zIndex: 10, background: "rgba(255,255,255,0.9)", border: "none", borderRadius: "50%", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}
      >
        <CiEdit size={24} color="#333" />
      </button>

      {saveMsg  && <div className="editor-toast">{saveMsg}</div>}
      {loading  && <div className="editor-loading"><div className="editor-loading__spinner" /></div>}
      {fetchErr && <div className="editor-error-banner">{fetchErr} <button onClick={fetchData}>Retry</button></div>}

      {modalOpen && (
        <ServiceEditModal
          data={pageData}
          onSave={handleSave}
          onClose={() => setModalOpen(false)}
          saving={saving}
          pageLabel="QHSE"
          extraFields={EXTRA_FIELDS}
        />
      )}

      {hasContent && (
        <div style={{ padding: 20 }}>
          {bannerImg && (
            <div className="img_carrier">
              <img src={bannerImg} alt="" style={{ maxWidth: "100%" }} />
            </div>
          )}

          <h1>{pageData.title}</h1>
          {pageData.intro       && <p>{pageData.intro}</p>}
          {pageData.quote       && <blockquote>{pageData.quote}</blockquote>}
          {pageData.subIntro    && <p>{pageData.subIntro}</p>}
          {pageData.policyIntro && <p>{pageData.policyIntro}</p>}

          {pageData.paragraphs.map((para, i) => (
            <p key={i}>{para}</p>
          ))}

          {pageData.sections.map((sec, i) => (
            <div key={i}>
              <h2>{sec.heading}</h2>
              {sec.items.map((item, j) => (
                <p key={j}>{item}</p>
              ))}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default Qhse;
